








































































import { defineComponent, nextTick, ref } from '@nuxtjs/composition-api'
import { VueMaskDirective } from 'v-mask'
import { computed } from '@vue/composition-api'
import { masks } from '@/validation'
import { FormInputType } from '@/contracts/FormInputType'
import { FormMask } from '@/contracts/FormMask'
import { defineProps } from '@/helpers/defineProps'

type InputTextProps = {
  id: string
  type: FormInputType
  label: string
  placeholder: string
  value: string
  maxLength: number
  disabled: boolean
  mask: typeof FormMask[keyof typeof FormMask]
  withBorder: boolean
  error: boolean | string
  tooltip: any
  withUpperCase: boolean
  withCapitalise: boolean
  isNewStyle: boolean
}

export default defineComponent({
  name: 'InputText',
  directives: {
    mask: VueMaskDirective,
  },
  model: {
    prop: 'value',
    event: 'input-change',
  },
  props: defineProps<InputTextProps>({
    id: { default: '' },
    type: { default: FormInputType.Text },
    label: { default: '' },
    placeholder: { default: '' },
    value: { default: '' },
    maxLength: { default: 1200 },
    disabled: { default: false },
    mask: { default: FormMask.NotSet },
    withBorder: { default: false },
    error: { default: false },
    tooltip: { default: '' },
    withUpperCase: { default: false },
    withCapitalise: { default: false },
    isNewStyle: { default: false },
  }),
  setup(props, { emit }) {
    const isActive = ref(false)
    const isFocused = ref(false)
    const inputRef = ref<HTMLInputElement | null>(null)

    const focusInput = async () => {
      await nextTick() // Дождёмся обновления DOM
      inputRef.value?.focus()
    }

    const inputMask = computed(() =>
      props.mask in masks ? masks[props.mask] : props.mask
    )

    const modifyInput = (value: string): string => {
      let result = value

      if (props.withUpperCase) {
        result = result.toUpperCase()
      }

      if (props.withCapitalise && /(^[а-яё]$)|(\s[а-яё]$)/.test(result)) {
        result = result.slice(0, -1) + result[result.length - 1].toUpperCase()
      }

      return result
    }

    const onInput = (event: Event) => {
      const el = event.target as HTMLInputElement
      const value = el.value

      emit('input-change', modifyInput(value))
    }

    return {
      isFocused,
      inputMask,
      onInput,
      isActive,
      inputRef,
      focusInput,
    }
  },
})
